/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import 'cross-fetch/polyfill';
import { SHOW_WPF_FIELDS_REQUEST, SHOW_WPF_FIELDS_REQUEST_FAIL, SHOW_WPF_FIELDS_RESPONSE_RECEIVE } from '@engine/actions/action-types';
/**
* Action Creators for Show WPF Fields
*/

export var showWpfFieldsResponseReceive = function showWpfFieldsResponseReceive(data) {
  return {
    type: SHOW_WPF_FIELDS_RESPONSE_RECEIVE,
    data: data
  };
};
export var showWpfFieldsRequestFail = function showWpfFieldsRequestFail() {
  return {
    type: SHOW_WPF_FIELDS_REQUEST_FAIL
  };
};
export var showWpfFieldsRequest = function showWpfFieldsRequest() {
  return {
    type: SHOW_WPF_FIELDS_REQUEST
  };
};
export function updateShowWpfFields(url, features) {
  return function (dispatch) {
    dispatch(showWpfFieldsRequest());
    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        authenticity_token: window.CSRF,
        features: features
      })
    }).then(function (response) {
      return response.json();
    }).then(function (json) {
      return dispatch(showWpfFieldsResponseReceive(json));
    })["catch"](function () {
      return dispatch(showWpfFieldsRequestFail());
    });
  };
}